// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1Hssh","emails":"CreateEditClinics_emails__2hh3T","emailTagLabel":"CreateEditClinics_emailTagLabel__3iTVl"};